<script setup>
import HiboutikForm from '@frontJs/components/forms/projectManagement/customers/externalServices/HiboutikForm.vue';
import ProjectManagementLayout from '@frontJs/layouts/ProjectManagementLayout.vue';
import { Head } from '@inertiajs/vue3';
import PageTitle from '@js/components/titles/PageTitle.vue';

const { tenant, externalService } = defineProps({
    tenant: {
        type: Object,
        required: true,
    },
    externalService: {
        type: Object,
        required: true,
    },
});

defineOptions({ layout: ProjectManagementLayout });
</script>

<template>
    <Head>
        <title>
            Hiboutik - Services externes - Clients - Gestion de projet -
            Datakepler
        </title>
    </Head>

    <PageTitle :tenant-name="tenant.name">
        Gestion de projet - Clients - Services externes - Hiboutik
    </PageTitle>

    <HiboutikForm :tenant="tenant" :external-service="externalService" />
</template>
